import type {
  AchFieldKeys,
  WireFieldKeys,
  CheckFieldKeys,
  BacsFieldKeys,
  SepaFieldKeys,
  EftFieldKeys,
  BecsFieldKeys,
  AchVisibleFields,
  WireVisibleFields,
  CheckVisibleFields,
  BacsVisibleFields,
  SepaVisibleFields,
  EftVisibleFields,
  BecsVisibleFields,
} from "../types";

// Generic base function
export const isFieldVisible = <T extends string>(
  fieldName: T,
  visibleFields?: T[],
): boolean => {
  if (!visibleFields) return true;
  return visibleFields.includes(fieldName);
};

// Typed helpers using existing field key types
export const isAchFieldVisible = (
  fieldName: AchFieldKeys,
  visibleFields?: AchVisibleFields,
): boolean => isFieldVisible(fieldName, visibleFields);

export const isWireFieldVisible = (
  fieldName: WireFieldKeys,
  visibleFields?: WireVisibleFields,
): boolean => isFieldVisible(fieldName, visibleFields);

export const isCheckFieldVisible = (
  fieldName: CheckFieldKeys,
  visibleFields?: CheckVisibleFields,
): boolean => isFieldVisible(fieldName, visibleFields);

export const isBacsFieldVisible = (
  fieldName: BacsFieldKeys,
  visibleFields?: BacsVisibleFields,
): boolean => isFieldVisible(fieldName, visibleFields);

export const isBecsFieldVisible = (
  fieldName: BecsFieldKeys,
  visibleFields?: BecsVisibleFields,
): boolean => isFieldVisible(fieldName, visibleFields);

export const isSepaFieldVisible = (
  fieldName: SepaFieldKeys,
  visibleFields?: SepaVisibleFields,
): boolean => isFieldVisible(fieldName, visibleFields);

export const isEftFieldVisible = (
  fieldName: EftFieldKeys,
  visibleFields?: EftVisibleFields,
): boolean => isFieldVisible(fieldName, visibleFields);
